import { displayErrors } from './module/displayErrors.js';
import { validateDonateInterval } from './module/validateDonateInterval.js';
import { scrollToError } from './module/scrollToError.js';
import { removeFieldError } from './module/removeFieldError.js';
import { validateSalutationRadios } from './module/validateSalutationRadios.js';
import { validatePaymentMethode } from './module/validatePaymentMethode.js';
import { validateAmountBlock } from './module/validateAmountBlock.js';
import { validateSchoolName } from './module/validateSchoolName.js';

(function () {
  const forms = document.querySelectorAll('[id^="webform-submission-from-donate"]');
  if (forms.length > 0) {
    forms.forEach((form) => {
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (validateForm(form)) {
          console.log('Formular ist valide!');
          form.submit();
        } else {
          console.log('Formular enthält Fehler.');
          scrollToError();
        }
      });
    });
  }
})();

const validateForm = (form) => {
  let errors = [];

  Array.from(form.elements).forEach(field => {
    if (field.name === 'interval') {
      validateDonateInterval(form, field, errors);
    }

    if (field.name === 'salutation') {
      validateSalutationRadios(form, field, errors);
    }
    if (field.name === 'payment_method') {
      validatePaymentMethode(form, field, errors);
    }
    if (field.name === 'amount_options') {
      validateAmountBlock(form, field, errors);
    }


    if (field.type === 'email' && field.hasAttribute('required')) {
      if (!validator.isEmail(field.value)) {
        errors.push({
          field,
          wrapper: field.closest('div'),
          wrapperErrorClasses: ['error-item', 'form__item'],
          wrapperSuccessClasses: ['valid-item', 'form__item'],
          message: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        });
      }
      field.addEventListener('input', () => {
        if (validator.isEmail(field.value)) {
          removeFieldError(field, errors, 'div');
        } else {
          errors.push({
            field,
            wrapper: field.closest('div'),
            wrapperErrorClasses: ['error-item', 'form__item'],
            wrapperSuccessClasses: ['valid-item', 'form__item'],
            message: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
          });
        }
      });
    }

    if (field.type === 'tel' && !validator.isEmpty(field.value)) {
      if (!validator.isMobilePhone(field.value)) {
        errors.push({
          field,
          wrapper: field.closest('div'),
          wrapperErrorClasses: ['error-item', 'form__item'],
          wrapperSuccessClasses: ['valid-item', 'form__item'],
          message: field.dataset.webformRequiredError || 'Dieses Feld ist erforderlich.',
        });
      }
      field.addEventListener('input', () => {
        if (validator.isMobilePhone(field.value)) {
          removeFieldError(field, errors, 'div');
        } else {
          errors.push({
            field,
            wrapper: field.closest('div'),
            wrapperErrorClasses: ['error-item', 'form__item'],
            wrapperSuccessClasses: ['valid-item', 'form__item'],
            message: field.dataset.webformRequiredError || 'Dieses Feld ist erforderlich.',
          });
        }
      });
    }

    if (field.name === 'iban' && !validator.isEmpty(field.value) && !validator.isIBAN(field.value)) {
      errors.push({
        field,
        wrapper: field.closest('div'),
        wrapperErrorClasses: ['error-item', 'form__item'],
        wrapperSuccessClasses: ['valid-item', 'form__item'],
        message: field.dataset.webformRequiredError || `"${field.value}" ist keine gültige IBAN.`,
      });
      field.addEventListener('input', () => {
        if (validator.isIBAN(field.value)) {
          removeFieldError(field, errors, 'div');
        } else {
          errors.push({
            field,
            wrapper: field.closest('div'),
            wrapperErrorClasses: ['error-item', 'form__item'],
            wrapperSuccessClasses: ['valid-item', 'form__item'],
            message: field.dataset.webformRequiredError || `"${field.value}" ist keine gültige IBAN.`,
          });
        }
      });
    }

    if (field.type === 'text' && field.hasAttribute('required') && validator.isEmpty(field.value)) {
      errors.push({
        field,
        wrapper: field.closest('div'),
        wrapperErrorClasses: ['error-item', 'form__item'],
        wrapperSuccessClasses: ['valid-item', 'form__item'],
        message: field.dataset.webformRequiredError || 'Dieses Feld ist erforderlich.',
      });
      field.addEventListener('input', () => {
        if (!validator.isEmpty(field.value)) {
          removeFieldError(field, errors, 'div');
        } else {
          errors.push({
            field,
            wrapper: field.closest('div'),
            wrapperErrorClasses: ['error-item', 'form__item'],
            wrapperSuccessClasses: ['valid-item', 'form__item'],
            message: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
          });
        }
      });
    }
    if (field.name === 'school_name') {
      validateSchoolName(form, field, errors);
    }
  });
  // console.log(errors);
  displayErrors(errors);

  return errors.length === 0;
};
